<template>
  <v-card v-if="haveDataToShow" :class="[margin]">
    <v-card-text>
      <h2 class="title mt-0 mb-3">{{ $t('edit-candidate-student-profile-step4-label', language) }}</h2>
      <ui-content class="sectionRow" v-if="profile.isInterestedInPartTimeJob !== null">
        <h3
          class="subheading question"
        >{{ $t('candidate-profile-is-interested-in-part-time-job-label', language) }}</h3>
        <span>{{ getYesNoLabel(profile.isInterestedInPartTimeJob) }}</span>
      </ui-content>

      <v-divider class="my-3" v-if="profile.isInterestedInJobAfterGraduating !== null" />
      <ui-content class="sectionRow" v-if="profile.isInterestedInJobAfterGraduating !== null">
        <h3
          class="subheading question"
        >{{ $t('candidate-profile-is-interested-in-job-after-graduating-label', language) }}</h3>
        <span>{{ getYesNoLabel(profile.isInterestedInJobAfterGraduating) }}</span>
      </ui-content>

      <v-divider
        class="my-3"
        v-if="translation && translation.dreamJobDescription !== null && translation.dreamJobDescription !== ''"
      />
      <ui-content
        class="sectionRow"
        v-if="translation && translation.dreamJobDescription !== null && translation.dreamJobDescription !== ''"
      >
        <h3
          class="subheading question"
        >{{ $t('candidate-profile-dream-job-description-label', language) }}</h3>
        <span>{{ translation.dreamJobDescription }}</span>
      </ui-content>

      <v-divider class="my-3" v-if="profile.homeCountryJobProspects !== null" />
      <ui-content class="sectionRow" v-if="profile.homeCountryJobProspects !== null">
        <h3
          class="subheading question"
        >{{ $t('candidate-profile-home-country-job-prospects-label', language) }}</h3>
        <span>{{ homeCountryJobProspects }}</span>
      </ui-content>
    </v-card-text>
  </v-card>
</template>

<script>
import { Consts } from '@/helpers/consts'

export default {
  data() {
    return {
      language: 'fr' // Always french for now
    }
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
    margin: {
      type: String,
      required: true
    }
  },
  computed: {
    haveDataToShow: function() {
      return this.profile.isInterestedInPartTimeJob !== null || this.profile.isInterestedInJobAfterGraduating !== null ||
        (this.translation && this.translation.dreamJobDescription !== null && this.translation.dreamJobDescription !== '') ||
        this.profile.homeCountryJobProspects !== null
    },
    translation: function() {
      return this.profile.translations.find(t => t.language === Consts.CONTENT_LANGUAGE_FR)
    },
    homeCountryJobProspects: function() {
      switch (this.profile.homeCountryJobProspects) {
        case Consts.HOME_COUNTRY_JOB_PROSPECTS_BAD:
          return this.$t('home-country-job-prospect-bad', this.language)
        case Consts.HOME_COUNTRY_JOB_PROSPECTS_GOOD:
          return this.$t('home-country-job-prospect-good', this.language)
        case Consts.HOME_COUNTRY_JOB_PROSPECTS_VERY_GOOD:
          return this.$t('home-country-job-prospect-very-good', this.language)
        case Consts.HOME_COUNTRY_JOB_PROSPECTS_UNKNOWN:
          return this.$t('home-country-job-prospect-unknown', this.language)
      }
    }
  },
  methods: {
    getYesNoLabel: function(value) {
      return value ? this.$t('yes-option', this.language) : this.$t('no-option', this.language)
    }
  }
}
</script>

<style>
.question {
  width: 77%;
}

.sectionRow {
  display: flex;
  justify-content: space-between;
}

.specification {
  font-style: italic;
}
</style>
